jQuery(function() {
  // Todo : remove jquery-shorten once the dependency is removed from all themes.
  var textCollapses = $('.text-collapse');

  textCollapses.shorten({
    moreText: textCollapses.data('readmoreText'),
    lessText: textCollapses.data('readlessText'),
    showChars: 700,
  });

  // Event performers collapses
  $('#collapse-performers').on('shown.bs.collapse', function () {
    var btnReadmore = $(this).next();
    var newText = btnReadmore.data('readlessText');
    btnReadmore.text(newText);
  });

  $('#collapse-performers').on('hidden.bs.collapse', function () {
    var btnReadmore = $(this).next();
    var newText = btnReadmore.data('readmoreText');
    btnReadmore.text(newText);
  });

  // Disable Scroll on Map
  $('#event-map').addClass('scrolloff');
  $('#map-overlay').on("mouseup", function() {
    $('#event-map').addClass('scrolloff');
  });
  $('#map-overlay').on("mousedown", function() {
    $('#event-map').removeClass('scrolloff');
  });
  $("#event-map").mouseleave(function () {
    $('#event-map').addClass('scrolloff');
  });
});
